var _excluded = ["EventCategory", "EventProvider", "EventSource", "EventSourceEntityType", "EventSourceEntityId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import Cookies from 'universal-cookie';
import retrieveUserToken from '../utils/user-token';
import sendBeacon from '../utils/send-beacon';
var getGAClientId = _ref => {
  var debug = _ref.debug;
  return new Promise((resolve, reject) => {
    if (typeof window === 'undefined') {
      if (debug) {
        console.log('backend-groupstats: No window object, returning undefined');
      }
      resolve();
    }
    try {
      if ('ga' in window) {
        if (debug) {
          console.log('backend-groupstats: `ga` object exists, returning client ID`');
        }
        window.ga(() => {
          var _window$ga$getAll, _window$ga$getAll$;
          resolve((_window$ga$getAll = window.ga.getAll()) === null || _window$ga$getAll === void 0 ? void 0 : (_window$ga$getAll$ = _window$ga$getAll[0]) === null || _window$ga$getAll$ === void 0 ? void 0 : _window$ga$getAll$.get('clientId'));
        });
      } else {
        if (debug) {
          console.log('backend-groupstats: No `ga` object exists, returning undefined`');
        }
        resolve();
      }
    } catch (error) {
      reject(error);
    }
  });
};
var GA4UserPseudoId = null;
var getGA4UserPseudoId = () => {
  var _cookies$get, _cookies$get$substrin;
  if (GA4UserPseudoId) {
    return GA4UserPseudoId;
  }

  // Get GA4 user_pseudo_id from cookie, ref:https://domain.atlassian.net/wiki/spaces/DACT/pages/2849802020/GA4+v.s.+UA+key+differences#user_pseudo_id
  var cookies = new Cookies();
  GA4UserPseudoId = (_cookies$get = cookies.get('_ga')) === null || _cookies$get === void 0 ? void 0 : (_cookies$get$substrin = _cookies$get.substring) === null || _cookies$get$substrin === void 0 ? void 0 : _cookies$get$substrin.call(_cookies$get, 6);
  return GA4UserPseudoId;
};
var query = "\n  mutation SendGroupStats($input: GroupStatsStat!, $validate: Boolean) {\n    postStat(groupStats: $input, validate: $validate)\n  }";
export default (_ref2 => {
  var shared = _ref2.shared,
    _ref2$endpoints = _ref2.endpoints,
    endpoints = _ref2$endpoints === void 0 ? {} : _ref2$endpoints;
  return event => {
    var getAbsoluteUrl = shared.getAbsoluteUrl,
      _shared$toggledFeatur = shared.toggledFeatures,
      toggledFeatures = _shared$toggledFeatur === void 0 ? {} : _shared$toggledFeatur;
    var _endpoints$graphql = endpoints.graphql,
      graphql = _endpoints$graphql === void 0 ? '/graphql' : _endpoints$graphql;
    var graphqlEndpoint = getAbsoluteUrl(graphql);
    var GROUP_STATS = toggledFeatures.GROUP_STATS,
      GROUP_STATS_VALIDATE_ONLY = toggledFeatures.GROUP_STATS_VALIDATE_ONLY,
      ANALYTICS_DEBUG = toggledFeatures.ANALYTICS_DEBUG;
    if (!GROUP_STATS) {
      if (ANALYTICS_DEBUG) {
        console.log('fe-co-allhomes-api: Group Stats disabled, dropping event'); // eslint-disable-line no-console
      }
      return;
    }
    var EventType = event.EventType,
      EventVersion = event.EventVersion,
      EventBrand = event.EventBrand,
      _event$MetaData = event.MetaData,
      MetaData = _event$MetaData === void 0 ? {} : _event$MetaData;
    var EventCategory = MetaData.EventCategory,
      EventProvider = MetaData.EventProvider,
      EventSource = MetaData.EventSource,
      EventSourceEntityType = MetaData.EventSourceEntityType,
      EventSourceEntityId = MetaData.EventSourceEntityId,
      additionalMetadata = _objectWithoutProperties(MetaData, _excluded);
    var userToken = retrieveUserToken();
    getGAClientId({
      debug: ANALYTICS_DEBUG
    }).catch(error => {
      if (ANALYTICS_DEBUG) {
        // eslint-disable-next-line no-console
        console.log('fe-co-allhomes-api: caught error finding GA Client ID: ', error);
      }
      return undefined;
    }).then(gaClientId => {
      if (ANALYTICS_DEBUG) {
        console.log('backend-groupstatus: Building GS object');
      }
      var data = {
        gaClientId,
        userToken,
        platform: 'Website',
        eventBrand: EventBrand,
        eventType: EventType,
        eventVersion: EventVersion,
        eventCategory: EventCategory,
        eventProvider: EventProvider,
        eventSource: EventSource,
        sourceEntityId: EventSourceEntityId,
        sourceEntityType: EventSourceEntityType,
        additionalMetadata: JSON.stringify(_objectSpread({
          GA4UserPseudoId: getGA4UserPseudoId()
        }, additionalMetadata))
      };
      var body = {
        query,
        variables: {
          validate: !!GROUP_STATS_VALIDATE_ONLY,
          input: data
        }
      };
      if (GROUP_STATS_VALIDATE_ONLY) {
        if (ANALYTICS_DEBUG) {
          console.log('Sending GroupStats message for validation', body);
        }
        fetch(graphqlEndpoint, _objectSpread({
          method: 'post'
        }, body && {
          body: JSON.stringify(body),
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json'
          }
        })).then(response => response.json()).then(content => {
          var _content$errors, _content$errors$, _content$extensions;
          var errorBody = (_content$errors = content.errors) === null || _content$errors === void 0 ? void 0 : (_content$errors$ = _content$errors[0]) === null || _content$errors$ === void 0 ? void 0 : _content$errors$.extensions;
          if ((errorBody === null || errorBody === void 0 ? void 0 : errorBody.code) === 'BAD_USER_INPUT') {
            console.error('GroupStats validation failed', errorBody); // eslint-disable-line no-console
          } else if (content.errors) {
            // eslint-disable-next-line no-console
            console.error('Caught error validating request', content.errors);
          } else if (content !== null && content !== void 0 && (_content$extensions = content.extensions) !== null && _content$extensions !== void 0 && _content$extensions.groupStats) {
            // eslint-disable-next-line no-console
            console.info('fe-co-allhomes-api: GroupStats event delivered', content.extensions.groupStats);
          }
        });
      } else {
        if (ANALYTICS_DEBUG) {
          console.log('Sending GroupStats message', body);
        }
        sendBeacon(graphqlEndpoint, {
          body,
          debug: ANALYTICS_DEBUG
        });
      }
    });
  };
});